import { LOAD_FSP_PROFILE } from 'model/export';
import { useIsBusy } from 'hooks';

const useIsProfileLoading = () => {
  return useIsBusy(LOAD_FSP_PROFILE);
};

export default useIsProfileLoading;
